"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _icon = require("@react-spectrum/icon");
var _ComponentRegistry = _interopRequireDefault(require("../../../util/ComponentRegistry"));
var _acrobat_reader_appicon_ = _interopRequireDefault(require("dc-icons/global/acrobat_reader_appicon_24.svg"));
var _ServiceRegistry = _interopRequireDefault(require("../../../util/ServiceRegistry"));
var _FileUtils = _interopRequireDefault(require("../../../util/FileUtils"));
var _Maximize = _interopRequireDefault(require("@react/react-spectrum/Icon/Maximize"));
require("!style-loader!css-loader!./FullScreenModal.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
*  Copyright 2020 Adobe
*  All Rights Reserved.
*
* NOTICE:  All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/

class FullScreenModal extends _react.default.Component {
  constructor() {
    super();
    this._appStore = _ServiceRegistry.default.getService("AppStore");
  }
  render() {
    const fileDisplayInfo = (0, _FileUtils.default)(this._appStore.fileInfoList[0].metaData);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "sdk-FullScreenModal-modalDialog",
      onClick: () => this._appStore.setInFullScreen(true),
      role: "presentation"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "sdk-FullScreenModal-header"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "sdk-FullScreenModal-branding",
      role: "presentation"
    }, _ComponentRegistry.default.hasComponent("AdobeDCIcon") ? _ComponentRegistry.default.getComponent("AdobeDCIcon") : /*#__PURE__*/_react.default.createElement(_icon.Icon, null, /*#__PURE__*/_react.default.createElement(_acrobat_reader_appicon_.default, null))), fileDisplayInfo && /*#__PURE__*/_react.default.createElement("div", {
      className: "sdk-FullScreenModal-fileInfo"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "sdk-FullScreenModal-fileInfo-fileName"
    }, fileDisplayInfo.displayFileName, /*#__PURE__*/_react.default.createElement("span", {
      className: "sdk-FullScreenModal-fileInfo-fileExtension",
      "aria-hidden": true
    }, fileDisplayInfo.extension)))), /*#__PURE__*/_react.default.createElement("div", {
      className: "sdk-FullScreenModal-maximizeIcon"
    }, /*#__PURE__*/_react.default.createElement(_Maximize.default, null)));
  }
}
var _default = exports.default = FullScreenModal;